import React, { useEffect } from 'react';
import {
  Modal,
  Form,
  Input,
  Button,
  Space,
  Row,
  Col
} from 'antd';
import { Customer } from '../../services/customerService';

const { TextArea } = Input;

interface CustomerModalProps {
  visible: boolean;
  onCancel: () => void;
  onSubmit: (data: any) => void;
  editingCustomer: Customer | null;
  loading?: boolean;
}

const CustomerModal: React.FC<CustomerModalProps> = ({
  visible,
  onCancel,
  onSubmit,
  editingCustomer,
  loading = false
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible) {
      if (editingCustomer) {
        form.setFieldsValue({
          code: editingCustomer.code,
          name: editingCustomer.name,
          phone: editingCustomer.phone,
          email: editingCustomer.email,
          address: editingCustomer.address,
          tax_code: editingCustomer.tax_code,
          contact_person: editingCustomer.contact_person,
          notes: editingCustomer.notes,
          status: editingCustomer.status
        });
      } else {
        form.resetFields();
      }
    }
  }, [visible, editingCustomer, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      onSubmit(values);
    } catch (error) {
      console.error('Form validation error:', error);
    }
  };

  return (
    <Modal
      title={editingCustomer ? 'Sửa khách hàng' : 'Thêm khách hàng mới'}
      open={visible}
      onCancel={onCancel}
      width={800}
      footer={
        <Space>
          <Button onClick={onCancel}>
            Hủy
          </Button>
          <Button type="primary" onClick={handleSubmit} loading={loading}>
            {editingCustomer ? 'Cập nhật' : 'Tạo khách hàng'}
          </Button>
        </Space>
      }
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="code"
              label="Mã khách hàng"
              rules={[
                { required: true, message: 'Vui lòng nhập mã khách hàng' },
                { max: 20, message: 'Mã khách hàng không được quá 20 ký tự' }
              ]}
            >
              <Input placeholder="Nhập mã khách hàng" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="name"
              label="Tên khách hàng"
              rules={[
                { required: true, message: 'Vui lòng nhập tên khách hàng' },
                { max: 100, message: 'Tên khách hàng không được quá 100 ký tự' }
              ]}
            >
              <Input placeholder="Nhập tên khách hàng" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="phone"
              label="Số điện thoại"
              rules={[
                { pattern: /^[0-9+\-\s()]*$/, message: 'Số điện thoại không hợp lệ' }
              ]}
            >
              <Input placeholder="Nhập số điện thoại" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="email"
              label="Email"
              rules={[
                { type: 'email', message: 'Email không hợp lệ' }
              ]}
            >
              <Input placeholder="Nhập email" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="tax_code"
              label="Mã số thuế"
              rules={[
                { max: 20, message: 'Mã số thuế không được quá 20 ký tự' }
              ]}
            >
              <Input placeholder="Nhập mã số thuế" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="contact_person"
              label="Người liên hệ"
              rules={[
                { max: 100, message: 'Tên người liên hệ không được quá 100 ký tự' }
              ]}
            >
              <Input placeholder="Nhập tên người liên hệ" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          name="address"
          label="Địa chỉ"
          rules={[
            { max: 200, message: 'Địa chỉ không được quá 200 ký tự' }
          ]}
        >
          <TextArea rows={3} placeholder="Nhập địa chỉ" />
        </Form.Item>

        <Form.Item
          name="notes"
          label="Ghi chú"
          rules={[
            { max: 500, message: 'Ghi chú không được quá 500 ký tự' }
          ]}
        >
          <TextArea rows={3} placeholder="Nhập ghi chú (nếu có)" />
        </Form.Item>

        {editingCustomer && (
          <Form.Item
            name="status"
            label="Trạng thái"
            initialValue="active"
          >
            <Input.Group compact>
              <Button
                type={form.getFieldValue('status') === 'active' ? 'primary' : 'default'}
                onClick={() => form.setFieldsValue({ status: 'active' })}
                style={{ width: '50%' }}
              >
                Hoạt động
              </Button>
              <Button
                type={form.getFieldValue('status') === 'inactive' ? 'primary' : 'default'}
                onClick={() => form.setFieldsValue({ status: 'inactive' })}
                style={{ width: '50%' }}
              >
                Không hoạt động
              </Button>
            </Input.Group>
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};

export default CustomerModal; 